import Redirect from '#root/ts/next.js/component/Redirect/index.js';

export default function Main() {
	return (
		<Redirect to="https://www.linkedin.com/in/lukeshadwell/?originalSubdomain=uk" />
	);
}
